"use strict";

(() => {
  const hoverIntentOpen = 60;
  const hoverIntentClose = 180;
  const bodyOpenClass = "mega-menu-open";
  const itemOpenClass = "is-opened";

  const isTouchDevice = () =>
    "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

  if (isTouchDevice()) return;

  const nav = document.querySelector(".section-header .navigation-main");
  if (!nav) return;

  const topItems = Array.from(nav.querySelectorAll(":scope > .navigation-item.has-sub-menu"));
  if (!topItems.length) return;

  const overlays = () => document.querySelectorAll(".mega-menu-overlay");

  let openTimer = null;
  let closeTimer = null;

  const isMegaItem = (item) => !!item.querySelector(":scope > .mega-menu");

  const lockBodyScroll = () => {
    if (document.body.classList.contains(bodyOpenClass)) return;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.setProperty("--mega-menu-scrollbar-width", `${scrollbarWidth}px`);
    document.body.classList.add(bodyOpenClass);
  };

  const unlockBodyScroll = () => {
    if (!document.body.classList.contains(bodyOpenClass)) return;
    document.body.classList.remove(bodyOpenClass);
    document.body.style.removeProperty("--mega-menu-scrollbar-width");
  };

  const setItemOpen = (item, open) => {
    item.classList.toggle(itemOpenClass, open);
    const sub = item.querySelector(":scope > .navigation-sub-menu");
    if (sub) sub.classList.toggle(itemOpenClass, open);
  };

  const forceClose = (item) => item.classList.add("force-close");
  const clearForceClose = (item) => item.classList.remove("force-close");

  const updateOverlayOffset = () => {
    const navWrapper = document.querySelector(".section-header .navigation-wrapper");
    const announcementBar = document.querySelector(".section-announcement-bar");
    const navBottom = navWrapper?.getBoundingClientRect().bottom ?? 0;
    const announcementBottom = announcementBar?.getBoundingClientRect().bottom ?? 0;
    const top = Math.max(navBottom, announcementBottom, 0);
    document.documentElement.style.setProperty("--mega-menu-overlay-top", `${top}px`);
  };

  const closeAll = () => {
    topItems.forEach((item) => {
      setItemOpen(item, false);
      forceClose(item);
    });
    overlays().forEach((overlay) => overlay.classList.remove("is-visible"));
    unlockBodyScroll();
  };

  const openItem = (item) => {
    clearForceClose(item);
    topItems.forEach((other) => setItemOpen(other, other === item));
    if (isMegaItem(item)) {
      updateOverlayOffset();
      overlays().forEach((overlay) => overlay.classList.toggle("is-visible", item.contains(overlay)));
      lockBodyScroll();
    } else {
      overlays().forEach((overlay) => overlay.classList.remove("is-visible"));
      unlockBodyScroll();
    }
  };

  const scheduleOpen = (item) => {
    clearTimeout(closeTimer);
    clearTimeout(openTimer);
    openTimer = setTimeout(() => openItem(item), hoverIntentOpen);
  };

  const scheduleClose = () => {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeAll, hoverIntentClose);
  };

  topItems.forEach((item) => {
    item.addEventListener("mouseenter", () => scheduleOpen(item));
    item.addEventListener("mouseleave", scheduleClose);
    item.addEventListener("focusin", () => openItem(item));
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest(".mega-menu-overlay")) closeAll();
  });

  document.addEventListener("keyup", (event) => {
    if (event.key === "Escape" || event.code === "Escape") closeAll();
  });

  nav.addEventListener("focusout", (event) => {
    if (!nav.contains(event.relatedTarget)) scheduleClose();
  });

  let resizeRaf = null;
  const onResize = () => {
    if (resizeRaf) return;
    resizeRaf = requestAnimationFrame(() => {
      resizeRaf = null;
      if (document.body.classList.contains(bodyOpenClass)) updateOverlayOffset();
    });
  };
  window.addEventListener("resize", onResize);
  window.addEventListener("scroll", onResize, { passive: true });
})();
